import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    card: {
      position: "relative",
      zIndex: 0,
      backgroundColor: theme.palette.placeholder,
      height: 0,
      paddingBottom: "150%",
      width: "100%",
    },
    cardImg: {
      display: "block",
      maxWidth: "100%",
    },
    overlay: {
      pointerEvents: "none",
      position: "absolute",
      zIndex: 2,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(37, 45, 95, 0.7)",
      display: "flex",
      transform: "visibility 0.1s ease-in",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
    },
    overlayLink: {
      position: "absolute",
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
    },
    overlayText: {
      lineHeight: 1,
      textAlign: "center",
      color: theme.palette.common.white,
      fontSize: theme.typography.pxToRem(30),
      fontStyle: "normal",
      fontWeight: 800,
      "@media (min-width: 550px)": {
        fontSize: theme.typography.pxToRem(48),
      },
      [theme.breakpoints.up("mobile")]: {
        fontSize: theme.typography.pxToRem(32),
      },
      [theme.breakpoints.up("tablet")]: {
        fontSize: theme.typography.pxToRem(48),
      },
    },
    overlayBtn: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.primary.main,
      marginTop: "20px",
      "&:hover": {
        transform: "none",
      },
    },
  }),
  { name: "StarringYou" },
);
